import { Component, Input, AfterViewInit, HostBinding } from '@angular/core';
@Component({
  selector: 'orca-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent implements AfterViewInit {

  @Input('type') type = '';
  @Input('name') name;
  @Input() size: 'normal' | 'small' = 'normal';

  @HostBinding('class.orca-input-small')
  get isSmall(): boolean {
    return this.size === 'small';
  }

  constructor(
  ) {

  }

  ngOnInit(): void {
    
  }

  ngAfterViewInit() {
   
    
  }
}
